import React from 'react'
import PropTypes from 'prop-types'
import { ButtonBase } from '@mui/material'

// Button dùng chung cho Popup Language với Popup Hotel
const ButtonConfirm = ({ onClick, label, ...props }) => {
  return (
    <ButtonBase
      onClick={onClick}
      {...props}
      sx={{
        backgroundColor: 'baseColor.color12',
        color: 'baseColor.colorText6',
        marginTop: '55px',
        borderRadius: '8px',
        padding: '12px 10px',
        fontSize: '2rem',
        fontWeight: '600',
        width: '100%',
        display: 'block',
      }}>
      {label}
    </ButtonBase>
  )
}

ButtonConfirm.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
}

export default React.memo(ButtonConfirm)
